import DesignContact from '../design/design-contact';
import MVPComments from './mvp-comment';
import MVPContact from './mvp-contact';
import MVPExpertise from './mvp-expertise';
import MVPIntro from './mvp-intro';
import MVPLaunched from './mvp-launched';
import MVPProcess from './mvp-process';
import MVPWhy from './mvp-why';
import styles from './mvp.module.css';

export default function MVP() {
  return (
    <>
      <div
        style={{
          background:
            'linear-gradient(180deg, #dedef5 0%, rgba(248, 248, 255, 0) 100%)',
        }}
      >
        <MVPIntro />
      </div>
      <MVPProcess />
      <MVPWhy />
      <MVPContact />
      <MVPLaunched />
      <MVPExpertise />
      <MVPComments />

      <section>
        <DesignContact
          title={
            // eslint-disable-next-line
            <h2 className={styles.h2} style={{ marginBottom: 14 }} id="contact">
              KICKSTART YOUR MVP JOURNEY WITH US
            </h2>
          }
        />
      </section>
    </>
  );
}
